import client from "libs/HttpClient";

/**
 * Service class for handling Carts.
 */
class CartService {
  /**
   * Adds a new Cart based on the provided request.
   *
   * @param request - The request parameters for adding a Cart.
   * @returns A Promise that resolves to the Axios response for the add Cart request.
   */
  static storePlanData(request: any) {
    return client.put("admin/cart/store-plan-data", request);
  }

  /**
   * get Order Details based on the provided request.
   *
   * @param request - The request parameters for getting a order.
   * @returns A Promise that resolves to the Axios response for the update order request.
   */
  static getCartDetails(request: any) {
    return client.get("admin/cart/get-order-details", request);
  }

  /**
   * Retrieves the details of a plan based on the provided parameters.
   *
   * @param params - The parameters for retrieving the plan details.
   * @returns A Promise that resolves to the Axios response containing the plan details.
   */
  static getPlanList(params: any) {
    return client.get("admin/cart/get-plan-list", { params });
  }

  /**
   * Deletes a Order Item based on the provided parameters.
   *
   * @param params - The parameters for deleting the Order Item.
   * @returns A Promise that resolves to the Axios response for the delete Order Item request.
   */
  static deleteCartItem(params: any) {
    return client.delete("admin/cart/delete-order-item/", { params });
  }

  /**
   * get Order Details based on the provided request.
   *
   * @param request - The request parameters for getting a order.
   * @returns A Promise that resolves to the Axios response for the update order request.
   */
  static getCartAddressDetails(request: any) {
    return client.get("admin/cart/get-cart-address", request);
  }

  /**
   * Adds a new Cart based on the provided request.
   *
   * @param request - The request parameters for adding a Cart.
   * @returns A Promise that resolves to the Axios response for the add Cart request.
   */
  static storeCartAddressData(request: any) {
    return client.put("admin/cart/store-cart-address", request);
  }

  /**
   * Adds a new Cart based on the provided request.
   *
   * @param request - The request parameters for adding a Cart.
   * @returns A Promise that resolves to the Axios response for the add Cart request.
   */
  static editCartAddressData(request: any) {
    return client.put("admin/cart/edit-cart-address", request);
  }

  /**
   * Store Payment L:ink based on the provided request.
   *
   * @param request - The request parameters for Send Payment Link.
   * @returns A Promise that resolves to the Axios response for the Send Payment Link.
   */
  static storePaymentLinkData(request: any) {
    return client.put("admin/cart/store-payment-link", request);
  }

  /**
   * Updates the ID of a Order Address based on the provided request.
   *
   * @param request - The request parameters for updating the ID of a Order Address.
   * @returns A Promise that resolves to the Axios response for the update ID of a Order Address request.
   */
  static updateOrderAddressId(request: any) {
    return client.put("admin/cart/update-address/", request);
  }
}

export { CartService };
